import { RuleAddContent, AddProduct, CompleteStep } from "./RuleAddContent";
RuleAddContent.AddProduct = AddProduct;
RuleAddContent.CompleteStep = CompleteStep;
export default RuleAddContent;
